
const getUser = (user_id) => {
    const user = JSON.parse(localStorage.getItem('userMap'));
    return user[user_id].email;
}
export default getUser;